import { Space, Typography, notification } from 'antd';
import { NotificationPlacement, IconType } from 'antd/es/notification';
import React from 'react';
import { TdsButton } from '../tds-button';

import './index.scss';

const CheckOutlined = () => <svg viewBox="64 64 896 896" focusable="false" data-icon="check" width="1em" height="1em" fill="currentColor" aria-hidden="true">
  <path d="M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"></path>
</svg>;

export interface ArgsProps {
  className?: string;
  /** 类型*/
  type?: IconType;
  /** 错误提示标题 */
  title?: string;
  /** 主要信息 */
  primaryText: string;
  /** 次要信息 */
  secondaryText?: string;
  /** 待拷贝信息，默认值为：主要信息+次要信息 */
  copyText?: string;
  /** 复制按钮标题，默认值为：复制错误信息 */
  copyBtnTitle?: string;
  /** 提示框展示位置，默认为：top */
  placement?: NotificationPlacement;
}

/**
 * 错误反馈弹框（包含弹框标题，主要信息与次要信息，支持指定待复制的信息）
 * 参考场景：接口出错需要弹框展示错误信息，以便用户更精准地反馈错误信息
 */
class CopyableNotification {
  private className = 'tds-copyable-notice-wrapper';
  private title = '操作出错';
  private copyBtnTitle = '复制错误信息';
  private placement: NotificationPlacement = 'top';

  public config(args: Pick<ArgsProps, 'className' | 'title' | 'copyBtnTitle' | 'placement'>) {
    const { className, title, copyBtnTitle, placement } = args;
    if (className) this.className = className;
    if (title) this.title = title;
    if (copyBtnTitle) this.copyBtnTitle = copyBtnTitle;
    if (placement) this.placement = placement;
  }

  public show(args: ArgsProps) {
    const { type = 'error', className, title, primaryText, secondaryText, copyText, copyBtnTitle, placement } = args;
    const key = `copyable_notice_${Date.now()}`;
    const contentNode = (
      <div className="copyable-notice-content">
        <Space direction="vertical" size={8}>
          <div>{primaryText}</div>
          {secondaryText ? <div>{secondaryText}</div> : null}
        </Space>
      </div>
    );
    const text = copyText || `${primaryText}|${secondaryText}`;
    const btnTitle = copyBtnTitle || this.copyBtnTitle;
    const btn = (
      <div className="copyable-notice-footer">
        <Typography.Text
          copyable={{
            text,
            icon: [
              <TdsButton
                key="copy"
                size="middle"
                onClick={() => setTimeout(() => notification.close(key), 1000)}
              >
                {btnTitle}
              </TdsButton>,
              <div className="copyable-notice-copied">
                已复制
                <CheckOutlined />
              </div>,
            ],
            tooltips: [false, false],
          }}
        />
      </div>
    );

    notification.open({
      message: title || this.title,
      placement: placement || this.placement,
      description: contentNode,
      className: className || this.className,
      type,
      key,
      btn,
    });
  }
}

const copyableNotification = new CopyableNotification();
export { copyableNotification };
